import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import ServiceDetail from './pages/ServiceDetail/ServiceDetail';
import Contact from './pages/Contact/Contact';
import Account from './pages/Account/Account';
import Login from './pages/Login/Login';
import Payment from './pages/Payment/Payment';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
// import ApiTester from './components/ApiTester/ApiTester'; // 接口测试按钮，需要时取消注释启用
import './App.scss';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="app">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:id" element={<ServiceDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/account" element={<Account />} />
            <Route path="/login" element={<Login />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        {/* <ApiTester /> */}
      </div>
    </BrowserRouter>
  );
}

export default App;
